import { Fragment, useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../components/table/tableComponent";
import TableSkeleton from "../../../../components/skeleton/tableSkeleton";

const TableHeaderData = ["Items", "Quantity", "Unit Price", "Amount"];
const InvoiceTable = ({ tableData }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <Table className="">
        <TableHeader>
          <TableRow>
            {TableHeaderData.map((header, i) => (
              <TableHead key={i}>{header}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <TableSkeleton colSpan={TableHeaderData.length} />
          ) : (
            <Fragment>
              {tableData?.length ? (
                tableData?.map((item, i) => (
                  <TableRow key={i}>
                    <TableCell>{item?.stock?.name || "-"}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>{item.unit_price || "-"}</TableCell>
                    <TableCell>
                      {item.quantity && item.unit_price
                        ? (item.quantity * item.unit_price).toFixed(2)
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <NoDataFound
                    search={""}
                    colSpan={TableHeaderData.length}
                    text="No data found."
                  />
                </TableRow>
              )}
            </Fragment>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default InvoiceTable;
